export default __webpack_public_path__ + "static/Chamal-c1b5acefae944a755fb8002ef4137223.png";